import React from 'react';

export const Settings = function(){
    return <>
        
    </>
}